import { render, staticRenderFns } from "./FengyouIntro.vue?vue&type=template&id=5b2846ff&scoped=true"
import script from "./FengyouIntro.vue?vue&type=script&lang=js"
export * from "./FengyouIntro.vue?vue&type=script&lang=js"
import style0 from "./FengyouIntro.vue?vue&type=style&index=0&id=5b2846ff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2846ff",
  null
  
)

export default component.exports